import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const Wrapper = styled.div``;

export const StyledStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GridItem = styled(Grid2)`
  flex-grow: 1;
`;

export const StyledGrid = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: 20px;
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-wrap: nowrap;
  }
`;
